import { useLoaderData } from "react-router-dom";

import ClientNotes from "./ClientNotes";

export default function ClientNotesFormWrapper({ data, questionKey }) {
  const { caseId, followUpId, formId } = useLoaderData();
  const caseObj = { id: caseId };
  const customURLPath = `actionable_items/${followUpId}/forms/${formId}/question/${questionKey}/`;
  return (
    <div className="h-[calc(100vh-120px)] max-h-[400px] min-h-0 w-full rounded-md overflow-hidden flex flex-col">
      <ClientNotes caseObj={caseObj} data={data} customURLPath={customURLPath} isHeightLimited={false}/>
    </div>
  );
}
